<template>
  <div id="ecommerce">
    <div v-if="isSelectedBot">
      <!--------------------------  start tab ----------------------------------------------------------------------------------------->
      <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
        <template v-if="role === 'nvbb_driver' && selectedBot.theme == 'nvbb'">
          <v-tab href="#nvbb-lalamove" ripple>{{ $t('Lalamove') }}</v-tab>
        </template>
        <template v-else>
          <v-tab
            v-if="
              (selectedBot.theme != 'lookchingiant' ||
                [...$store.state.lamyPage].includes(selectedBot.pageid)) &&
              !(selectedBot.theme === 'seagull' && $store.state.privilege.role === 'warehouse')
            "
            href="#Products"
            ripple
            >{{ $t('Products') }}</v-tab
          >
          <v-tab
            v-if="$store.state.nestlePages.some((page) => page.pageid == selectedBot.pageid)"
            href="#Bundles"
            ripple
          >
            {{ $t('Bundles') }}
          </v-tab>
          <v-tab
            v-if="
              showProductAnalytic &&
              ((!['scgdistribution'].includes(selectedBot.theme) &&
                !['thailandpostmart'].includes(selectedBot.type)) ||
                [
                  '100684322285177',
                  '109154847972476',
                  '182366355126026',
                  '490162721055346',
                  '178737485661189'
                ].includes(selectedBot.pageid)) &&
              !(selectedBot.theme === 'seagull' && $store.state.privilege.role === 'warehouse')
            "
            href="#ProductAnalytics"
            ripple
            >{{ $t('Sales Report') }}</v-tab
          >
          <v-tab
            v-if="
              (!['nvbb', 'runkan', 'lookchingiant', 'tcp'].includes(selectedBot.theme) &&
                !['thailandpostmart'].includes(selectedBot.type) &&
                !(
                  selectedBot.theme === 'seagull' && $store.state.privilege.role === 'warehouse'
                )) ||
              ['182366355126026'].includes(selectedBot.pageid)
            "
            href="#cartsummary"
            ripple
            >{{ $t('Cart Summary') }}</v-tab
          >

          <v-tab
            v-if="
              [
                '109154847972476',
                '108496771338010',
                '100378482209868',
                '107060654853653',
                '109181747969457',
                '103800371873416',
                '108308318379330',
                '101127682506041',
                '100274418904517',
                '108556638438120',
                '108026141827592',
                '490162721055346',
                '115739694445355',
                '100396882225293',
                '178737485661189'
              ].includes(selectedBot.pageid)
            "
            href="#cartreport"
            ripple
            >{{ $t('Cart Summary History') }}</v-tab
          >

          <v-tab
            v-if="
              (!['scgdistribution'].includes(selectedBot.theme) &&
                !['thailandpostmart'].includes(selectedBot.type)) ||
              [
                '100684322285177',
                '109154847972476',
                '182366355126026',
                '490162721055346',
                '178737485661189'
              ].includes(selectedBot.pageid)
            "
            href="#ecommerce-order-summary"
            ripple
            >{{ selectedBot.theme == 'nvbb' ? $t('Cart Summary') : $t('Order Summary') }}</v-tab
          >
          <template v-if="selectedBot.theme == 'nvbb'">
            <v-tab href="#nvbb-order-summary" ripple>{{ $t('Pre-order Summary') }}</v-tab>
            <v-tab href="#nvbb-lalamove" ripple>{{ $t('Lalamove') }}</v-tab>
          </template>
          <v-tab v-if="$aston.astonpages.includes(selectedBot.pageid)" ripple href="#aston-ads">{{
            $t('Aston')
          }}</v-tab>
          <v-tab
            v-if="$aston.astonpages.includes(selectedBot.pageid)"
            ripple
            href="#AstonAuction"
            >{{ $t('Auction') }}</v-tab
          >
          <template v-if="selectedBot.pageid == '853384435005817'">
            <v-tab href="#BearhouseOrder" ripple>{{ $t('Order Summary') }} 2</v-tab>
          </template>
          <!-- v-if="['foodguru','runkan'].includes(selectedBot.theme)" -->
          <template
            v-if="
              !['thailandpostmart'].includes(selectedBot.type) &&
              !['tcp'].includes(selectedBot.theme) &&
              !(selectedBot.theme === 'seagull' && $store.state.privilege.role === 'warehouse')
            "
          >
            <v-tab href="#Promotion" ripple>{{ $t('Coupon') }}</v-tab>
          </template>
          <!-- <v-tab
          v-if="!['lookchingiant', 'runkan', 'scgdistribution'].includes(selectedBot.theme)"
          href="#Wholesale"
          ripple
          >{{ $t('All Wholesale') }}</v-tab
        > -->
          <v-tab v-if="['cityfresh'].includes(selectedBot.theme)" href="#CouponReport" ripple>{{
            $t('coupon_report')
          }}</v-tab>
          <v-tab
            v-if="
              (!['lookchingiant', 'scgdistribution', 'tcp'].includes(selectedBot.theme) &&
                !['thailandpostmart'].includes(selectedBot.type) &&
                !(
                  selectedBot.theme === 'seagull' && $store.state.privilege.role === 'warehouse'
                )) ||
              [
                '100684322285177',
                '109154847972476',
                '182366355126026',
                '490162721055346',
                '178737485661189'
              ].includes(selectedBot.pageid)
            "
            href="#Payment"
            ripple
            >{{ $t('Payments') }}</v-tab
          >
          <template v-if="selectedBot.theme == 'nvbb'">
            <v-tab href="#NvbbSummaryDrink" ripple>
              {{ $t('สรุปยอดผลิต') }}
            </v-tab>
          </template>
          <v-tab
            v-if="
              (!['scgdistribution', 'tcp'].includes(selectedBot.theme) &&
                !['thailandpostmart'].includes(selectedBot.type) &&
                !(
                  selectedBot.theme === 'seagull' && $store.state.privilege.role === 'warehouse'
                )) ||
              ['100684322285177', '109154847972476', '490162721055346', '178737485661189'].includes(
                selectedBot.pageid
              )
            "
            href="#ShippingMethod"
            ripple
            >{{ $t('Shipping Method') }}</v-tab
          >
          <v-tab
            v-if="['103876431747147', '176922345693076'].includes(selectedBot.pageid)"
            href="#Influencers"
            ripple
            >{{ $t('Influencers') }}</v-tab
          >
          <v-tab v-if="['tcp'].includes(selectedBot.theme)" href="#OrderStatistics" ripple>{{
            $t('order_statistics')
          }}</v-tab>
          <v-tab v-if="isTremendous" href="#setting" ripple>{{ $t('Setting') }}</v-tab>
        </template>
      </v-tabs>
      <!--------------------------  end tab ----------------------------------------------------------------------------------------->

      <!-- ------------------------  start components --------------------------------------------------------------------------------------- -->
      <div v-if="currentView == 'Products'">
        <component
          :is="$store.state.subcategory.includes(selectedBot.pageid) ? 'KanomProducts' : 'Products'"
        ></component>
      </div>
      <div v-else-if="currentView == 'ecommerce-order-summary'">
        <component :is="'ecommerce-order-summary'"></component>
      </div>
      <div v-else-if="currentView == 'nvbb-order-summary'">
        <component :is="'nvbb-order-summary'"></component>
      </div>
      <div v-else-if="currentView == 'nvbb-lalamove'">
        <component :is="'nvbb-lalamove'"></component>
      </div>
      <div v-else-if="currentView == 'aston-ads'">
        <aston-ads></aston-ads>
      </div>
      <div v-else-if="currentView == 'aston-auction'">
        <aston-auction></aston-auction>
      </div>
      <div v-else-if="currentView == 'Wholesale'">
        <wholesale></wholesale>
      </div>
      <div v-else-if="currentView == 'Payment'">
        <payment></payment>
      </div>
      <div v-else-if="currentView == 'BearhouseOrder'">
        <bearhouse-order></bearhouse-order>
      </div>
      <div v-else-if="currentView == 'bearhouse-order2'">
        <bearhouse-order2></bearhouse-order2>
      </div>
      <div v-else-if="currentView == 'ProductAnalytics'">
        <product-analytics v-if="showProductAnalytic"></product-analytics>
      </div>
      <div v-else-if="currentView == 'cartsummary'">
        <cart-summary-scgdistribute
          v-if="selectedBot.theme == 'scgdistribution'"
        ></cart-summary-scgdistribute>
        <cart-summary v-else></cart-summary>
      </div>
      <div v-else-if="currentView == 'cartreport'">
        <cart-report-scgdistribute
          v-if="
            [
              '109154847972476',
              '108496771338010',
              '100378482209868',
              '107060654853653',
              '109181747969457',
              '103800371873416',
              '108308318379330',
              '101127682506041',
              '100274418904517',
              '108556638438120',
              '108026141827592',
              '490162721055346',
              '115739694445355',
              '100396882225293',
              '178737485661189'
            ].includes(selectedBot.pageid)
          "
        ></cart-report-scgdistribute>
      </div>
      <div v-else-if="currentView == 'ShippingMethod'">
        <shipping-method></shipping-method>
      </div>
      <div v-else-if="currentView == 'OrderStatistics'">
        <OrderStatistics></OrderStatistics>
      </div>
      <div v-else-if="currentView == 'setting'">
        <EcommerceSetting></EcommerceSetting>
      </div>
      <div v-else>
        <component :is="currentView"></component>
      </div>
    </div>
    <div v-else>
      <template-empty></template-empty>
    </div>
  </div>
</template>

<script>
import powerbuyShopServicesApi from '@/api/powerbuy-shop-services'
import Influencers from '@/components/view/influencer/Influencers.vue'
import TemplateEmpty from '@/components/view/template/template-empty'
import { mapGetters } from 'vuex'
import AstonAds from './AstonAds'
import AstonAuction from './AstonAuction.vue'
import BearhouseOrder from './BearhouseOrder'
import BearhouseOrder2 from './BearhouseOrder2'
import Bundles from './Bundles/Bundles'
import CartReportScgdistribute from './CartReportScgdistribute.vue'
import CartSummary from './CartSummary.vue'
import CartSummaryScgdistribute from './CartSummaryScgdistribute.vue'
import CouponReport from './CouponReport'
import EcommerceOrderSummary from './ecommerce-order-summary'
import KanomProducts from './KanomProducts'
import NvbbLalamove from './nvbb-lalamove'
import NvbbOrderSummary from './nvbb-order-summary'
import NvbbSummaryDrink from './NvbbSummaryDrink'
import NvbbSummaryDrinkPhytoMylk from './NvbbSummaryDrinkPhytoMylk'
import NvbbSummaryDrinkPhytoShot from './NvbbSummaryDrinkPhytoShot'
import NvbbSummaryDrinkPhytoSmooz from './NvbbSummaryDrinkPhytoSmooz'
import OrderStatistics from './OrderStatistics/OrderStatistics.vue'
import Payment from './Payment'
import ProductAnalytics from './ProductAnalytics.vue'
import Products from './Products'
import Promotion from './Promotion.vue'
import ShippingMethod from './ShippingMethod.vue'
import Shippop from './Shippop.vue'
import Wholesale from './Wholesale'
import EcommerceSetting from './EcommerceSetting'
import { PAGE } from '../../../../constants/page'

export default {
  components: {
    TemplateEmpty,
    Products,
    KanomProducts,
    EcommerceOrderSummary,
    Payment,
    Wholesale,
    AstonAds,
    BearhouseOrder,
    BearhouseOrder2,
    ProductAnalytics,
    AstonAuction,
    NvbbOrderSummary,
    CartSummary,
    CartSummaryScgdistribute,
    CartReportScgdistribute,
    Promotion,
    ShippingMethod,
    Shippop,
    Influencers,
    NvbbSummaryDrink,
    NvbbSummaryDrinkPhytoSmooz,
    NvbbSummaryDrinkPhytoMylk,
    NvbbSummaryDrinkPhytoShot,
    NvbbLalamove,
    CouponReport,
    Bundles,
    OrderStatistics,
    EcommerceSetting
  },
  data: function () {
    return {
      currentView: 'products',
      role: null
    }
  },
  created() {
    let vm = this
    if (vm.$route.query.tab) {
      // switch (vm.$route.query.tab) {
      //   case 'products':
      //   case 'ecommerce-category':
      //   case 'ecommerce-order-summary':
      //   case 'bearhouse-order':
      //   case 'wholesale':
      //   case 'aston-auction':
      //   case 'product-analytic':
      //   case 'cart-summary':
      //   case 'payment':
      //   case 'promotion':
      //     vm.currentView = vm.$route.query.tab
      //     break
      //   default:
      //     vm.currentView = 'products'
      //     break
      // }
      vm.currentView = vm.$route.query.tab
    } else if (vm.selectedBot.theme == 'lookchingiant') {
      vm.currentView = 'ProductAnalytics'
    } else if (vm.selectedBot.theme == 'seagull') {
      vm.currentView = 'ecommerce-order-summary'
    } else {
      vm.currentView = 'Products'
    }
  },
  mounted() {
    if (localStorage.getItem('privilege')) {
      this.role = JSON.parse(localStorage.getItem('privilege')).role
      if (this.role === 'nvbb_driver') {
        this.currentView = 'nvbb-lalamove'
      }
    }

    if (['powerbuy'].includes(this.selectedBot.theme)) {
      this.handleGetPowerbuyBranchList()
    }
  },

  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      getBotPageRole: 'getBotPageRole',
      isFacebook: 'isFacebook'
    }),
    // ecommerceComponent() {
    //   const component_name = this.currentView
    //   return () => import(`./${component_name}.vue`)
    // },
    isTremendous() {
      return PAGE.TREMENDOUS.includes(this.selectedBot.pageid)
    },

    isSelectedBot: function () {
      return this.$store.state.isSelectedBot
    },
    showProductAnalytic() {
      return (
        this.getBotPageRole ||
        ['361231620965547', '853384435005817'].includes(this.selectedBot.pageid) ||
        !this.isFacebook
      )
    }
  },
  methods: {
    updateRoute: function () {
      this.$router.push({
        name: 'template',
        path: '/template',
        query: {
          ...this.$route.query,
          tab: this.currentView
        }
      })
      this.routeValue = JSON.stringify(this.$route.query)
    },
    async handleGetPowerbuyBranchList() {
      const vm = this
      try {
        let data = {
          pageId: vm.selectedBot.pageid,
          limit: vm.limit,
          offset: vm.offset
        }

        vm.$store.dispatch('loading')
        const response = await powerbuyShopServicesApi.getBranchList({
          config: {
            params: data
          }
        })

        vm.$store.dispatch('loading')
        if (response && response.status === 200) {
          vm.$store.state.powerbuyBranchList = response.data.data
        } else {
          return null
        }
      } catch (error) {
        vm.$store.dispatch('loading')
        console.error(error)
      }
    }
  },
  watch: {
    currentView: function () {
      this.updateRoute()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ecommerce.vue